import { PAYMENT_METHOD_HASH_TYPE_PAYPAL } from '../../constants';

export const paypalPaymentMethodHashPayloadFactory = (): object => ({
  type: PAYMENT_METHOD_HASH_TYPE_PAYPAL,
});
